<template>
  <div>

        <div class="container" v-if="loaded">

            <Upgrade v-bind:factsheet="factsheet" v-if="loaded" />

            <div class="row">
                <div class="col-7">
                    <h2>Table of Contents</h2>
                    <ul id="toc" class="collapsed">
                        <li><a href="#introduction"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 1. Administrative</a></li>
                        <li><a href="#landcover"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 2. Land Cover</a></li>
                        <li><a href="#topography"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 3. Topography</a></li>
                        <li><a href="#climate"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 4. Climate</a></li>
                        <li><a href="#soils"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 5. Soils</a></li>
                        <li><a href="#water"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 6. Hydrology and Water Resources</a></li>
                        <li><a href="#agriculture"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> 7. Agriculture</a></li>
                        <li><a href="#notes"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> Notes</a></li>
                        <li><a href="#references"><i class="fas fa-angle-down" style="font-size:0.8em;"></i> References</a></li>
                    </ul>
                </div>
                <div class="col-5">
                    
                </div>
            </div>

        </div>

        <Administrative v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />
        
        <Landcover v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <Topography v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <Climate v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <Soils v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <Hydrology v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <Agriculture v-bind:location="location" v-bind:factsheet="factsheet" v-bind:loaded="loaded" v-if="loaded" />

        <Notes v-if="loaded" />

        <References v-if="loaded" />

  </div>
</template>

<script>
/* eslint-disable */
  import _ from 'lodash'; 

  import Administrative from '@/components/factsheet/basic/Administrative.vue'
  import Topography from '@/components/factsheet/basic/Topography.vue'
  import Landcover from '@/components/factsheet/basic/Landcover.vue'
  import Climate from '@/components/factsheet/basic/Climate.vue'
  import Soils from '@/components/factsheet/basic/Soils.vue'
  import Hydrology from '@/components/factsheet/basic/Hydrology.vue'
  import Agriculture from '@/components/factsheet/basic/Agriculture.vue'

  import References from '@/components/factsheet/basic/References.vue'
  import Notes from '@/components/factsheet/basic/Notes.vue'

  import Upgrade from '@/components/generic/Upgrade.vue'
  
  import omnivore from "@mapbox/leaflet-omnivore";
  
  export default {
    name: 'factsheetbasic',
    props: ['location', 'factsheet', 'loaded'],
    components: {
        Upgrade,
        Administrative, 
        Landcover, 
        Topography, 
        Climate, 
        Soils, 
        Hydrology, 
        Agriculture, 
        References, 
        Notes
    },
    data() {
        return {
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    }
  }
</script>


<style>
body {
    color:#666;
}
div.factsheet {
    font-size:1.5em;
}

div.factsheet h1 {
    font-size:1.3em;
    font-weight:600;
    //margin-top:15px;
}

div.factsheet h2 {
    font-size:1.2em;
    font-weight:600;
    margin-top:15px;
}

div.factsheet h3 {
    font-size:1.05em;
    font-weight:600;
    margin-top:15px;
}

div.factsheet p {
    line-height:1.4em;
}

div.factsheet ul li {
    padding:7px 0px 7px 0px;
}

div.factsheet table td {
    color:#666;
    line-height:1.4em;
}

ul.collapsed {
    list-style-type:none;
    margin-left:0px;
    padding-left:0px;
    margin-bottom:5px;
}
ul.collapsed li {
    margin-left:0px;
}

div.data-availability ul {
    list-style-type:none;
    margin-left:0px;
    padding-left:0px;
    margin-bottom:5px;
}
div.data-availability ul li {
    margin-left:0px;
}
div.factsheet-status-error {
    margin:20px 0px;
    padding:20px 20px 6px 20px;
    font-size:0.8em;
    border-radius:0px;
    color:#e50000;
    border:2px solid #e50000;
    background-color:#fff0f0;
}
div.factsheet-status-ok {
    margin:20px 0px;
    padding:20px 20px 6px 20px;
    font-size:0.8em;
    border-radius:0px;
    color:#378c07;
    border:2px solid #15b01a;
    background-color:#e8fae9
}
div.factsheet-status-notice {
    margin:20px 0px;
    padding:20px 20px 6px 20px;
    font-size:0.8em;
    border-radius:0px;
    color:#666;
    border:2px solid #ffd152;
    background-color:#ffffe4
}
</style>
